import React from 'react';
import type { Worker } from '../../api/workersApi';
import CreateHandlerFormV2, { type CreateHandlerPreset } from './CreateHandlerFormV2';

interface Props {
  workers: Worker[];
  preset: CreateHandlerPreset | null;
  aiOpenRequestId: number;
  onCancel: () => void;
  onCreated: () => void;
}

export default function HandlerCatalogRegisterPaneV2({ workers, preset, aiOpenRequestId, onCancel, onCreated }: Props) {
  const selectedHandlerKey = String(preset?.handler_key ?? '').trim();

  return (
    <div className="h-full min-h-0 flex flex-col">
      <div className="shrink-0">
        <div className="text-xl font-semibold" title={selectedHandlerKey ? `Register handler - ${selectedHandlerKey}` : 'Register handler'}>
          Register handler{selectedHandlerKey ? ` - ${selectedHandlerKey}` : ''}
        </div>
        <div className="mt-1 text-sm text-neutral-400">
          Handlers map workflow steps to a worker and runtime policy.
        </div>
      </div>

      <div className="flex-1 min-h-0 overflow-hidden mt-3">
        <CreateHandlerFormV2
          workers={workers}
          preset={preset}
          aiOpenRequestId={aiOpenRequestId}
          onCancel={onCancel}
          onCreated={onCreated}
        />
      </div>
    </div>
  );
}
